var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-divider',[_vm._v(_vm._s(_vm.title))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }